// ── §66+§67+§65: Unified Entry Point — Create Project ────────────────────────

interface Props {
  onClose: () => void
  onGenerateAI: () => void
  onFigma: () => void
  onScratch: () => void
  onScreenshot?: () => void
  onImportUrl?: () => void
}

interface Option {
  icon: string
  title: string
  subtitle: string
  action: () => void
  highlight?: boolean
  badge?: string
}

export function NewProjectModal({ onClose, onGenerateAI, onFigma, onScratch, onScreenshot, onImportUrl }: Props) {
  const options: Option[] = [
    {
      icon: '✨',
      title: 'Создать с AI',
      subtitle: 'Опишите сайт — AI сгенерирует структуру, тексты и стиль',
      action: () => { onClose(); onGenerateAI() },
      highlight: true,
      badge: 'Рекомендуем',
    },
    {
      icon: '🖼️',
      title: 'Из скриншота',
      subtitle: 'Загрузите скриншот сайта — AI воссоздаст его дизайн и структуру',
      action: () => { onClose(); onScreenshot?.() },
      badge: 'Vision AI',
    },
    {
      icon: '🌐',
      title: 'Импорт по URL',
      subtitle: 'Введите адрес сайта — система проанализирует структуру и создаст проект',
      action: () => { onClose(); onImportUrl?.() },
      badge: '§64',
    },
    {
      icon: '🎨',
      title: 'Импорт из Figma',
      subtitle: 'Загрузите ссылку на Figma-файл — получите готовый сайт',
      action: () => { onClose(); onFigma() },
    },
    {
      icon: '📄',
      title: 'Начать с нуля',
      subtitle: 'Пустая страница с полным набором блоков',
      action: () => { onClose(); onScratch() },
    },
  ]

  return (
    <div
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}
      onClick={e => { if (e.target === e.currentTarget) onClose() }}
    >
      <div style={{
        background: '#fff', borderRadius: 20, width: '100%', maxWidth: 520,
        boxShadow: '0 24px 80px rgba(0,0,0,0.25)', overflow: 'hidden',
        fontFamily: 'system-ui, sans-serif',
      }}>
        {/* Header */}
        <div style={{ padding: '28px 32px 20px', borderBottom: '1px solid #f3f4f6' }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
            <div>
              <div style={{ fontSize: 22, fontWeight: 800, color: '#111', marginBottom: 4 }}>Создать проект</div>
              <div style={{ fontSize: 13, color: '#6b7280' }}>Выберите способ создания сайта</div>
            </div>
            <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#9ca3af', marginTop: -4 }}>×</button>
          </div>
        </div>

        {/* Options */}
        <div style={{ padding: '20px 24px 28px', display: 'flex', flexDirection: 'column', gap: 12 }}>
          {options.map((opt, i) => (
            <button
              key={i}
              onClick={opt.action}
              style={{
                display: 'flex', alignItems: 'center', gap: 16, padding: '16px 18px',
                border: `2px solid ${opt.highlight ? '#5b6af0' : '#e5e7eb'}`,
                borderRadius: 14, cursor: 'pointer', textAlign: 'left', fontFamily: 'inherit',
                background: opt.highlight ? 'linear-gradient(135deg, #f0f1ff 0%, #faf0ff 100%)' : '#fff',
                transition: 'border-color 0.15s, box-shadow 0.15s',
              }}
              onMouseEnter={e => {
                (e.currentTarget as HTMLButtonElement).style.borderColor = '#5b6af0'
                ;(e.currentTarget as HTMLButtonElement).style.boxShadow = '0 4px 16px rgba(91,106,240,0.15)'
              }}
              onMouseLeave={e => {
                (e.currentTarget as HTMLButtonElement).style.borderColor = opt.highlight ? '#5b6af0' : '#e5e7eb'
                ;(e.currentTarget as HTMLButtonElement).style.boxShadow = 'none'
              }}
            >
              <div style={{
                width: 48, height: 48, borderRadius: 14, flexShrink: 0,
                background: opt.highlight ? '#5b6af0' : '#f3f4f6',
                display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22,
              }}>
                {opt.icon}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 3 }}>
                  <span style={{ fontSize: 15, fontWeight: 700, color: '#111' }}>{opt.title}</span>
                  {opt.badge && (
                    <span style={{ fontSize: 10, fontWeight: 700, color: '#5b6af0', background: '#ede9fe', padding: '2px 7px', borderRadius: 8 }}>
                      {opt.badge}
                    </span>
                  )}
                </div>
                <div style={{ fontSize: 12, color: '#6b7280', lineHeight: 1.4 }}>{opt.subtitle}</div>
              </div>
              <span style={{ fontSize: 18, color: '#9ca3af', flexShrink: 0 }}>→</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}
